import { render, staticRenderFns } from "./slickCarouselAnimation.vue?vue&type=template&id=53d4f034&"
import script from "./slickCarouselAnimation.vue?vue&type=script&lang=js&"
export * from "./slickCarouselAnimation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports